import { Component, input, output } from '@angular/core';
import { CwActionIcon, CwIcon } from '@bbraun/cortex-angular';
import { iconsMap } from '~/app/constants/notificationIconsMap';
import { SafeHtmlPipe } from '~/app/pipes/SafeHtml';

@Component({
  selector: 'gplus-snackbar',
  imports: [CwIcon, SafeHtmlPipe, CwActionIcon],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
  host: {
    'animate.leave': 'fade-out',
    'animate.enter': 'fade-in'
  }
})
export class SnackbarComponent {
  public title = input<string>();
  public text = input<string>();
  public timestamp = input<string>();
  public type = input<string>();
  public icon = input<string>();
  public closeable = input<boolean>(null);

  public closed = output<void>();

  public iconsMap: { [key: string]: string } = iconsMap;
}
